import React from 'react'

import { SectionContainer } from 'Components/Blocks'
import AppearingWrapper from 'Components/Blocks/AppearingWrapper'
import { Button, Column, Row, Text } from 'Components/UI'
import { DateTime } from 'luxon'
import { NewsItem } from 'Types/emajinAPI'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import { useResponsiveLayout } from 'Hooks'

import { Container, Overlay } from './styles'

type Props = {
  data?: NewsItem
  onAction?: () => void
}

function BlogPostHeroSection({ data, onAction }: Props) {
  const { isDesktop } = useResponsiveLayout()

  if (!data) return null

  return (
    <SectionContainer>
      <Row px={LANDING_CONTENT_PX}>
        <Container mt={[0, 0, 5]} px={[20, 20, 104]} py={[54, 54, 104]}>
          {data.attachments?.length && (
            <img alt="" src={data.attachments[0].url} />
          )}

          <Overlay />

          <Column alignCenter={!isDesktop} alignStart={isDesktop} gap={6}>
            <AppearingWrapper centered={!isDesktop} kind="expand">
              <Text
                as="h3"
                bold
                center={!isDesktop}
                inverse
                mb={5}
                mt={3}
                screen40={!isDesktop}
                screen52={isDesktop}
              >
                {data.name}
              </Text>
            </AppearingWrapper>

            <Text
              center={!isDesktop}
              inverse
              mb={7}
              screen14={!isDesktop}
              screen20={isDesktop}
            >
              {DateTime.fromISO(data.createdAt).toFormat('MMM dd, yyyy')}
            </Text>

            <Button large mb={6} onClick={onAction}>
              Sign Up
            </Button>
          </Column>
        </Container>
      </Row>
    </SectionContainer>
  )
}

export default BlogPostHeroSection
